import { useMutation } from '@tanstack/react-query';
import { updateBrand, IUpdateBrandResponse } from 'src/api/updateBrand';
import { useNotifications } from '@weareopenr/component-library';
import { useUserTracking } from '../useUserTracking/useUserTracking';

export const useUpdateBrand = (onMutationSuccess: () => void) => {
  const setMessage = useNotifications();
  const { captureException } = useUserTracking();

  return useMutation(
    (params: { id: string; name?: string; file?: File | null }) =>
      updateBrand(params.id, params.name, params.file),
    {
      onSuccess: (data: IUpdateBrandResponse) => {
        setMessage({
          message: (
            <>
              <strong>{data.name}</strong> has successfully been edited.
            </>
          ),
          severity: 'success',
        });
        onMutationSuccess();
      },
      onError: (error, req) => {
        setMessage({
          message: (
            <>
              Unable to edit <strong>{req.name}</strong>
            </>
          ),
          severity: 'error',
        });
        captureException(error);
      },
    },
  );
};
